module.exports = __webpack_public_path__ + "img/AKEAD_Logo_new_.198ef88e.svg";